import { Http } from "@/plugins/http.js";

export class TasksRepository {
  /**
   * @type {TaskDuration[]}
   * @private
   */
  static _durations = [];
  /**
   * @type {TaskPeriodicity[]}
   * @private
   */
  static _periodicity = [];

  /**
   * @type {TaskGroup[]}
   * @private
   */
  static _groups = [];

  /**
   * @type {TaskScheduledEventType[]}
   * @private
   */
  static _types = [];

  /**
   *
   * @return Promise<TaskDuration[]>
   */
  static async duration() {
    if (TasksRepository._durations.length) {
      return TasksRepository._durations;
    }

    const { data } = await Http.get(`v1/events/duration`, { params: { lang: "ru" } });
    const items = data.data ?? [];
    TasksRepository._durations = items;

    return items;
  }

  /**
   *
   * @return Promise<TaskPeriodicity[]>
   */
  static async periodicity() {
    if (TasksRepository._periodicity.length) {
      return TasksRepository._periodicity;
    }

    const { data } = await Http.get(`v1/events/periodicity`, { params: { lang: "ru" } });
    const items = data.data ?? [];
    TasksRepository._periodicity = items;

    return items;
  }

  /**
   * Список групп(это список группированных задач, из карты наблюдений) заданий
   * @param {number} customerId
   * @return Promise<TaskGroup[]>
   */
  static async groups(customerId) {
    if (TasksRepository._groups.length) {
      return TasksRepository._groups;
    }

    const { data } = await Http.get(`v1/customers/${customerId}/scheduled-events/groups`, { params: { lang: "ru" } });
    const items = data.data ?? [];
    TasksRepository._groups = items;

    return items;
  }

  /**
   * Список типов по которым группируются ивенты
   * @param {number} customerId
   * @return Promise<TaskScheduledEventType[]>
   */
  static async types(customerId) {
    if (TasksRepository._types.length) {
      return TasksRepository._types;
    }

    /** @var {TaskScheduledEventType[]} items */
    const items = [
      { id: "param", name: "Параметры" },
      { id: "symptom", name: "Контроль симптома" },
      { id: "reminder", name: "Произвольные задания" },
    ];
    TasksRepository._types = items;

    return items;
  }

  /**
   * Список временных периодов
   * @return Promise<TaskGroupPeriod[]>
   */
  static async groupsByPeriods() {
    /** @var {TaskGroupPeriod[]} items */
    const items = [
      { id: "days", name: "По дням" },
      { id: "week", name: "По неделям" },
      { id: "month", name: "По месяцам" },
      { id: "quartets", name: "По кварталам" },
      { id: "years", name: "По годам" },
    ];

    return items;
  }

  /**
   * Список типов заданий
   *
   * @return Promise<TaskType[]>
   */
  static async taskTypesList() {
    /** @var {TaskType[]} items */
    const items = [
      { id: "param", name: "Параметры" },
      { id: "symptom", name: "Контроль симптома" },
      { id: "reminder", name: "Произвольные задания" },
    ];

    return items;
  }

  /**
   * @param {number} customerId
   * @param {TaskScheduleEventCreate} event
   * @returns {Promise<any>}
   */
  static async create(customerId, event) {
    const { data } = await Http.post(`v1/customers/${customerId}/scheduled-events`, event);

    return data;
  }

  /**
   * @param {number} customerId
   * @param {number} eventId
   * @param {TaskScheduledEventUpdate} event
   * @returns {Promise<boolean>}
   */
  static async update(customerId, eventId, event = {}) {
    const { data } = await Http.put(`v1/customers/${customerId}/scheduled-events/${eventId}`, event);

    return data;
  }

  /**
   * @param {number} customerId
   * @param {number} eventId
   * @returns {Promise<boolean>}
   */
  static async delete(customerId, eventId) {
    try {
      const response = await Http.delete(`v1/customers/${customerId}/scheduled-events/${eventId}`, { params: { lang: "ru" } });

      if (response.status === 204) {
        return true;
      }
    } catch (e) {
      //
    }

    return false;
  }

  /**
   * @param {number} customerId
   * @param {object} groupData
   * @returns {Promise<any>}
   */
  static async addGroup(customerId, groupData) {
    const { data } = await Http.post(`v1/customers/${customerId}/scheduled-events/groups`, groupData);

    return data;
  }
}
